import React, { memo, SVGProps } from 'react';

const ButtonLine = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="439"
			height="84"
			viewBox="0 0 439 84"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<mask id="theMask" maskUnits="userSpaceOnUse">
					<path
						id="button-line"
						d="M1.50001 33C61 131 172.296 61.415 170.057 19.4227C169.034 0.229778 146.047 -5.99521 136.214 15.313C116.902 57.1634 188.819 88.9829 233.5 66.5C312 27 367 5 438 27"
						stroke="#fff"
						strokeWidth="2"
					/>
				</mask>
			</defs>

			<g id="maskReveal" mask="url(#theMask)">
				<path
					d="M1.50001 33C61 131 172.296 61.415 170.057 19.4227C169.034 0.229778 146.047 -5.99521 136.214 15.313C116.902 57.1634 188.819 88.9829 233.5 66.5C312 27 367 5 438 27"
					stroke="url(#paint0_linear_1629_39091)"
					strokeWidth="2"
					strokeLinecap="round"
					strokeDasharray="16 16"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_1629_39091"
						x1="298"
						y1="5.5"
						x2="407.502"
						y2="35.2538"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FF8541" />
						<stop offset="1" stopColor="#FF8541" stopOpacity="0" />
					</linearGradient>
				</defs>
			</g>
		</svg>
	);
};

export default memo(ButtonLine);
